export default __webpack_public_path__ + "static/media/banner1.f8276890.png";